import GameIntro from "./GameIntro";

export default GameIntro;